var exports = {
  "n": "xe7b6e3d6--c40281--link",
};

module.exports = exports;
